"use strict";

exports.__esModule = true;
exports.Cart = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Cart = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      width: "100%",
      height: "300px"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      children: "TODO : build cart"
    })
  });
};
exports.Cart = Cart;